import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './app/config';
import store from './app/store'
import { Provider } from 'react-redux'

import Footer from './module/Footer';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <Provider store={store}>
    <div>
      <App />
      <Footer/>
    </div>

   </Provider>
   
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
